import { css } from '@emotion/core';
import { rgba, variables } from '@domain-group/fe-brary';
var colour = variables.colour;
export var spinner = {
  name: "11nq4b8",
  styles: "position:absolute;height:120%;text-align:center;"
};
export var overlay = /*#__PURE__*/css("position:absolute;width:100%;height:100%;padding-top:100px;z-index:", variables.global.layerModal, ";background-color:", rgba(colour.white, 0.9), ";");